var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavedOffericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52026 8.75229C9.47763 9.46706 11.6109 9.46706 13.5683 8.75229",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8452 1H5.24463C2.90239 1 1 2.91338 1 5.24463V20.7386C1 22.718 2.41854 23.5537 4.15598 22.597L9.52225 19.617C10.0941 19.2981 11.0178 19.2981 11.5786 19.617L16.9449 22.597C18.6823 23.5647 20.1008 22.729 20.1008 20.7386V5.24463C20.0898 2.91338 18.1875 1 15.8452 1Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8452 1H5.24463C2.90239 1 1 2.91338 1 5.24463V20.7386C1 22.718 2.41854 23.5537 4.15598 22.597L9.52225 19.617C10.0941 19.2981 11.0178 19.2981 11.5786 19.617L16.9449 22.597C18.6823 23.5647 20.1008 22.729 20.1008 20.7386V5.24463C20.0898 2.91338 18.1875 1 15.8452 1Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedOffericon);
export default __webpack_public_path__ + "static/media/savedOffericon.cc4eb8112c04f3d5c948baba829e57ff.svg";
export { ForwardRef as ReactComponent };